import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { IUserSessionStore, LOCAL_STORAGE_USER_PROFILE } from '../user.types'

export const defaultUserSession: IUserSessionStore = {
  user: {
    id: '',
    firstName: '',
    lastName: '',
    username: '',
    phone: '',
    aircallUserId: '',
    email: '',
  },
  membership: {
    id: '',
    status: '',
  },
  currentOrganization: {
    id: '',
    name: '',
  },
  organizations: [],
  policies: [],
}

interface UserState {
  userSession: IUserSessionStore
  isNoteBlockerActive: boolean
}

const initialState: UserState = {
  userSession: { ...defaultUserSession },
  isNoteBlockerActive: false,
}

const clearObsoleteProfile = () => {
  try {
    localStorage.removeItem(LOCAL_STORAGE_USER_PROFILE)
  } catch {
    // Storage may be unavailable; profile restoration never depends on it.
  }
}

clearObsoleteProfile()

const userStore = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserSession: (
      state,
      action: PayloadAction<Partial<IUserSessionStore>>,
    ) => {
      state.userSession = {
        ...state.userSession,
        ...action.payload,
      }
    },
    setNoteBlockerActive: (state, action: PayloadAction<boolean>) => {
      state.isNoteBlockerActive = action.payload
    },
    resetUserSessionStore: (state) => {
      state.userSession = { ...defaultUserSession }
      state.isNoteBlockerActive = false
      clearObsoleteProfile()
    },
  },
})

export const { setUserSession, setNoteBlockerActive, resetUserSessionStore } =
  userStore.actions
export default userStore.reducer
